import React from "react";
export default function WorkFlow_3_Icon(fillColor) {
  return (
    <div style={{ marginRight: "8px" }}>
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          y="0.28125"
          width="24"
          height="24"
          rx="12"
          fill={fillColor.color}
        />
        <path
          d="M11.457 17.4453C13.4326 17.4453 14.8818 16.2285 14.8818 14.5811V14.5674C14.8818 13.166 13.9043 12.2705 12.4688 12.1475V12.1201C13.6992 11.8604 14.5605 11.0264 14.5605 9.80957V9.7959C14.5605 8.29883 13.3232 7.25293 11.4434 7.25293C9.59766 7.25293 8.32617 8.32617 8.16895 9.93262L8.16211 10.001H9.34473L9.35156 9.93262C9.4541 8.93457 10.2812 8.31934 11.4434 8.31934C12.6465 8.31934 13.3232 8.91406 13.3232 9.94629V9.95996C13.3232 10.9443 12.5029 11.6689 11.3271 11.6689H10.1445V12.708H11.3818C12.7627 12.708 13.6309 13.3848 13.6309 14.5947V14.6084C13.6309 15.6543 12.749 16.3789 11.457 16.3789C10.1445 16.3789 9.24902 15.709 9.15332 14.7383L9.14648 14.6699H7.96387L7.9707 14.752C8.10059 16.3105 9.41992 17.4453 11.457 17.4453Z"
          fill="white"
        />
      </svg>
    </div>
  );
}
